export default "__VITE_ASSET__88c64ed2__"